import React, { useEffect, useRef, useState } from "react";
import HeaderComponents from "../../components/HeaderComponents";
import "../../utils/Style/pages/ToDo.scss";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import useTodoApi from "../../api/TodoApi";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import { resetResponse, setBillReferences, setTodoActiveButton } from "../../features/TodoSlice";
import useDropOffApi from "../../api/DropOffApi";
import { set } from "rsuite/esm/internals/utils/date";
import { Spinner } from "react-bootstrap";
import { clearWebSocketMessage } from '../../features/webSocketSlice'; 
import { v4 as uuidv4 } from 'uuid';
import { WebPubSubClient } from "@azure/web-pubsub-client";


function OrderToPrepare() {
  const [currentStep, setCurrentStep] = useState(1);
  const [currencySymbol, setCurrencySymbol] = useState();
  const [errors, setErrors] = useState({});
  const [serialNumber, setSerialNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [buttonText, setButtonText] = useState("Send Request");


  const { GetOrderQr, qrCode, ConfirmOrder, confirmMessage, SetSerialNumber, SaveBillReference, GetOrdersToProcessCount, ResetOderPreparation} = useTodoApi();

  const todoOrderDetails = useSelector((state) => state.todo.todoOrderDetails);
  const serialNumberResponse = useSelector((state) => state.todo.serialNumberResponse);
  const saveBillReferenceResponse = useSelector((state) => state.todo.saveBillReferenceResponse);
  const ordersTodo = useSelector(state => state.todo.ordersToDo)
  const billReferences = useSelector((state) => state.todo.billReferences);
  const webSocketMessage = useSelector((state) => state.websocket.webSocketMessage);
  const webSocketClient = useSelector(state => state.websocket.webSocketClient)
  const reset = useSelector(state => state.todo.resetResponseApi)

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setBillReferences(("")))
  }, [])

  useEffect(() => {
    if (ordersTodo && ordersTodo.length > 0 && todoOrderDetails && todoOrderDetails.id) {
      const currentOrder = ordersTodo.find(order => order.orderID === todoOrderDetails.id);
  
      if (currentOrder) {
        if (currentOrder.orderStep === "set-billreference") {
          setCurrentStep(2);
        } else if (currentOrder.orderStep === "scanQr") {
          setCurrentStep(3);
        }
      }
    }
  }, [ordersTodo, todoOrderDetails]);
  
  
  // const fetchClipboardText = async () => {
  //   try {
  //     if (navigator.clipboard && navigator.clipboard.readText) {
  //       let text = await navigator.clipboard.readText();
  //       console.log("Fetched clipboard text: ", text);

  //       if (text.includes('BillReferenceGenerated$$$$')) {
  //         const cleanedText = text.replace(/BillReferenceGenerated\${4}/g, '').trim();
  //         console.log("Cleaned clipboard text: ", cleanedText);

  //         if (cleanedText !== billReferences) {
  //           dispatch(setBillReferences(cleanedText));
  //           console.log("Updated Redux state with clipboard text");

  //           if (textareaRef.current) {
  //             textareaRef.current.value = cleanedText;
  //             console.log("Updated textarea value with clipboard text");
  //           }
  //         }
  //       } else {
  //         console.log('Clipboard content does not match BillReferenceGenerated$$$$, skipping update');
  //       }
  //     } else {
  //       console.warn('Clipboard API not available, falling back to manual input');
  //     }
  //   } catch (err) {
  //     console.error('Failed to read clipboard contents: ', err); 
  //   }
  // };
  
  // const handleTextareaFocus = () => {
  //   fetchClipboardText(); 

  //   intervalRef.current = setInterval(() => {
  //     fetchClipboardText(); 
  //   }, 10000);
  // };

  // const handleTextareaBlur = () => {
  //   if (intervalRef.current) {
  //     clearInterval(intervalRef.current);
  //     console.log("Stopped clipboard pasting as textarea lost focus");
  //   }
  // };

  const printQr = useRef();

  const handleSendMessage = () => {
    const guid = uuidv4();
    const channelID = 27; 
    const groupName = "CashPickup-Employee";  
    
    if (webSocketClient) {
      const message = {
        Guid: guid,
        ChannelID: channelID
      };
  
      webSocketClient.sendToGroup(groupName, JSON.stringify(message), "text")
        .then(() => {
          console.log(`Message sent to group ${groupName}: ${JSON.stringify(message)}`);
          setButtonText("Message Sent");
          
          setTimeout(() => {
            setButtonText("Send Request");
          }, 4000);
        })
        .catch((error) => {
          console.error("Failed to send message:", error);
        });
    } else {
      console.error("WebSocket is not connected");
    }
  };
  
  const handleDismissed = () => {
    dispatch(setTodoActiveButton({ name: "OrderTable" }));
    dispatch(resetResponse())
  };

  const handleDone = () => {
    GetOrdersToProcessCount();
    dispatch(setTodoActiveButton({ name: "OrderTable" }));
    dispatch(resetResponse())
  };

  const handleCurrentStep = () => {
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1);
    }
  };
  
  useEffect(() => {
    return () => {
      dispatch(resetResponse());
    };
  }, []);

  const handleContinueSerialNumber = async () => {
    if (validateForm()) {
      setIsLoading(true);
      try {
        if (currentStep === 1) {
          await SetSerialNumber(todoOrderDetails.id, serialNumber);  
          dispatch(resetResponse())
        }
      } catch (error) {
        console.error("Error in setting serial number:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (serialNumberResponse?.data?.flagCode === 0 && currentStep === 1) {
      handleCurrentStep();
      dispatch(resetResponse());
    } else if (serialNumberResponse?.data?.flagCode === 1) {
      setErrors({
        SerialNumber: serialNumberResponse.data.title || "Error setting serial number",
      });
    } else if (serialNumberResponse?.data?.flagCode === -1) {
      setErrors({
        SerialNumber: serialNumberResponse.data.message || "An error has occurred while setting the serial number.",
      });
    }
  }, [serialNumberResponse, currentStep]);


  useEffect(() => {
    if (webSocketMessage) {
      // const formattedMessage = JSON.stringify(webSocketMessage, null, 2);
      // dispatch(setBillReferences(formattedMessage));

      const messageData = JSON.parse(webSocketMessage.message.data);

      if (messageData.Event === "CashPickUpDelivery-BillReference") {
        const payloadData = JSON.parse(messageData.Payload);
        const formattedMessage = {
          Currencies: payloadData.Currencies.map(currency => ({
            Currency: currency.Currency,
            Summary: currency.Summary,
            Bills: currency.Bills.map(bill => ({
              Amount: bill.Amount,
              SerialNumber: bill.SerialNumber
            }))
          })
        )};


  // Convert the object to JSON string
  const formattedMessageString = JSON.stringify(formattedMessage, null, 2);

  // Dispatch the formatted message
  dispatch(setBillReferences(formattedMessageString));
  dispatch(clearWebSocketMessage());
    }
  }
  }, [webSocketMessage, dispatch]);
  const formatBillReferencesAsHTML = (billReferences) => {
    if (!billReferences) return '';
  
    const parsedData = JSON.parse(billReferences);
  
    let formattedText = '';
  
    parsedData.Currencies.forEach((currency) => {
      formattedText += `<div class="currency" style="margin-bottom: 5px;">`;
      formattedText += `<p><strong>Currency:</strong> ${currency.Currency}</p>`;
      formattedText += `<p><strong>Count:</strong> ${currency.Summary.Count}</p>`;
      formattedText += `<p><strong>Total Amount:</strong> ${currency.Summary.TotalAmount}</p>`;
      formattedText += `<hr style="border: 2px solid #000; margin: 10px 0x;" />`; 
      formattedText += `<p><strong>Bills:</strong></p>`;
      
      formattedText += `<p>`;
      currency.Bills.forEach((bill, index) => {
        formattedText += `${bill.Amount} ${bill.SerialNumber}`;
        if (index < currency.Bills.length - 1) {
          formattedText += ` <br/>`; 
        }
      });
      formattedText += `</p>`;
  
      formattedText += `</div>`;
    });

    return formattedText;
  };
  
  const handleContinue = async () => {
    if (validateForm()) {
      setIsLoading(true);
      try {
        if (currentStep === 2) {
          await SaveBillReference(todoOrderDetails.id, billReferences); 
          dispatch(resetResponse());
        }
      } catch (error) {
        console.error("Error saving bill reference:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (saveBillReferenceResponse?.data?.payload?.flagCode === 0 && currentStep === 2) {
      handleCurrentStep(); 
      dispatch(resetResponse());
    }
  }, [saveBillReferenceResponse, currentStep]);

  useEffect(() => {
    if (currentStep === 3) {
      GetOrderQr(todoOrderDetails.id); 
    }
  }, [currentStep, todoOrderDetails.id]);
  
  const handleConfirm = () => {
    ConfirmOrder(todoOrderDetails.id);
    handleCurrentStep();
    dispatch(resetResponse());
  };


  useEffect(() => {
    if (todoOrderDetails && todoOrderDetails.currency === "USD") {
      setCurrencySymbol("$");
    } else {
      setCurrencySymbol("L.L");
    }
  }, [todoOrderDetails]);

  const handlePrint = useReactToPrint({
    content: () => printQr.current,
  });

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    
    if (currentStep === 1) {
      if (!serialNumber.trim()) {
        newErrors.SerialNumber = "Serial Number is required";
        isValid = false;
      }
    }
  
    if (currentStep === 2) {
      if (!billReferences.trim()) {
        newErrors.BillReferences = "Bill References is required";
        isValid = false;
      }
    }
  
    setErrors(newErrors);
    return isValid;
  };
  
  const handleSerialNumberChange = (e) => {
    const value = e.target.value;
    // if (/^\d*$/.test(value)) {
      setSerialNumber(value);
    // }
  };

  const handleBack = () => {
    if (currentStep === 2) {
      setCurrentStep(1);
    } else if (currentStep === 3) {
      setCurrentStep(2)
    }
  }
  

  const handleReset = async () => {
    setResetLoading(true);
    try {
        const resetResponse = await ResetOderPreparation(todoOrderDetails.id); 

        if (resetResponse.flagCode === 0) {

            setCurrentStep(1);
            setSerialNumber("");
            setErrors({});
        } else if (resetResponse.flagCode === 1 || resetResponse.flagCode === -1) {
            setErrors({ ResetError: resetResponse.message });
        }
    } catch (error) {
        console.error(error);
        setErrors({ ResetError: "An error occurred while resetting the order." });
    } finally {
        setResetLoading(false);
    }
};  
  
  return (
    <>
      <div className="ToDoPage">
        <div className="TodoContainerPage">
          <div className="OrderID">
            <img src="/Images/NewOrders.svg" alt="Order Icon" />
            <div className="numberID">OrderID {todoOrderDetails.id}</div>
            <div className="orderStatus">New</div>
          </div>
          <div className="orderBox">
            <div className="boxHeader">OrderID {todoOrderDetails.id}</div>
              <ProgressBar
                currentStep={currentStep}
                steps={[
                  "Envelope Serial Number",
                  "Prepare Amount",
                  "Generate QR",
                ]}
              />

            {currentStep === 1 && (
              <div className="orderDetails">
                <div className="orderId">
                  <div className="boxLabel">Envelope Serial Number</div>
                  <input
                    type="text"
                    className="orderID-input"
                    placeholder="- - - - - -"
                    value={serialNumber}
                    onChange={handleSerialNumberChange}
                    disabled={isLoading}
                    maxLength={6}  
                    pattern="[A-Za-z0-9]{0,6}"
                  />
                </div>
                {errors.SerialNumber && (
                  <div className="error-dropOff m-1" style={{ paddingLeft: "230px" }}>
                    {errors.SerialNumber}
                  </div>
                )}
                <div className="buttons">
                  <button className="dismissed-btn" onClick={handleDismissed}>
                    Dismissed
                  </button>
                  <button
                    className="continue-btn"
                    onClick={() => handleContinueSerialNumber()}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                        <Spinner animation="border" size="sm" /> 
                    ) : (
                      "Confirm & Continue"
                    )}
                  </button>
                  
                </div>
              </div>
            )}


            {currentStep === 2 && (
              <div className="orderDetails">
                <div className="send-request">
                <button className="send-request-btn" onClick={handleReset} disabled={resetLoading}>
                  {resetLoading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "Reset"
                  )}
                  </button>
                  <button className="send-request-btn" onClick={handleSendMessage} disabled={buttonText === "Message Sent"} >
                  {buttonText} 
                </button>
                </div>
                {errors.ResetError && (
              <div className="reset-error mt-2">
                {errors.ResetError}
              </div>
            )}

                <div className="orderAmount">
                  <div className="boxLabel">Ordered Amount</div>
                  <div className="amountNumber">
                      {currencySymbol} {todoOrderDetails.amount}
                  </div>
                </div>
                <div className="orderAmount">
                  <div className="boxLabel">Driver Name</div>
                  <div className="driverName">
                      {todoOrderDetails.driverName}
                  </div>
                </div>
                <div className="billReferences">
                <div className="boxLabel">Bill References</div>
                <div className="billHtmlView bordered-div" dangerouslySetInnerHTML={{ __html: formatBillReferencesAsHTML(billReferences) }}></div>
                {errors.BillReferences && (
                  <div className="error m-0">{errors.BillReferences}</div>
                )}
              </div>

                <div className="buttons">
                <button className="continue-btn" onClick={handleBack}>
                    Back
                  </button>
                  <button className="dismissed-btn" onClick={handleDismissed}>
                    Dismissed
                  </button>
                  <button className="continue-btn" onClick={handleContinue} disabled={isLoading}>
                    {isLoading ? (
                        <Spinner animation="border" size="sm" /> 
                    ) : (
                      "Confirm & Continue"
                    )}
                  </button>
                </div>
              </div>
            )}

            {currentStep === 3 && (
              <div className="orderDetails">
                <div className="send-request">
                  <button className="send-request-btn" onClick={handleReset} disabled={resetLoading}>
                  {resetLoading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "Reset"
                  )}
                  </button>
                </div>
                {errors.ResetError && (
                  <div className="reset-error mt-2">
                    {errors.ResetError}
                  </div>
                )}
                <div className="qrOrder">
                  <div className="boxLabel">QR for Order</div>
                  <div className="qrOrderinput" ref={printQr} style={{textAlign: "center"}}>
                  <img 
                  src={qrCode}
                  alt="QR Code" />
                  <div className="order-numberID" style={{textAlign: "center"}}>
                    OrderID <span className="id-mumber">{todoOrderDetails.id}</span>
                  </div>
                </div>
                </div>
                <div className="button-order">
                  <button className="print-btn" onClick={handlePrint}>
                    Print QR
                  </button>
                </div>
                <div className="buttons">
                <button className="continue-btn" onClick={handleBack}>
                    Back
                  </button>
                  <button className="dismissed-btn" onClick={handleDismissed}>
                    Dismissed
                  </button>
                  <button className="continue-btn" onClick={handleConfirm}>
                    Confirm
                  </button>
                </div>
              </div>
            )}

            {currentStep === 4 && (
              <div className="orderDetails">
                <div className="successOrder">
                  <img src="/Images/check.png" alt="Success" />
                  <div className="success-message">
                    <div className="bold-text">
                      {confirmMessage && confirmMessage.title}
                    </div>
                    {confirmMessage && confirmMessage.message}
                  </div>
                </div>
                <div className="buttons">
                  <button className="done-btn" onClick={handleDone}>
                    Done
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderToPrepare;
